// extracted by mini-css-extract-plugin
module.exports = {"container":"requirementalertlist_container__3FHYD"};